var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-attribute pointer is-inline-block",on:{"click":_vm.handleCopyAttribute}},[_c('BIcon',{attrs:{"icon":"copy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }